import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AdminLayoutComponent } from "./components/admin-layout/admin-layout.component";
import { UserManagementComponent } from "./components/user-management/user-management.component";
import { AuditLogComponent } from "./components/audit-log/audit-log.component";
import { AuditItemsComponent } from "./components/audit-items/audit-items.component";
import { authGuard } from "../../shared/guards/auth.guard";

const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,    
    canActivateChild: [authGuard],
    data: { roles: ['Admin'] },
    children: [
      { path: '', redirectTo: 'user-management', pathMatch: 'full', },
      { path: 'user-management', component: UserManagementComponent },
      { path: 'audit-log', component: AuditLogComponent },
      { path: 'audit-log/:auditId/audit-items', component: AuditItemsComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }